import { Typography, Button, HorizontalDivider } from 'components/UI/atoms'

import { Modal } from '../modal'

type Props = {
	isModalOpen: boolean
	onCloseModal: () => void
	title: string
	description: string
}

const ComingSoonModal = ({
	isModalOpen,
	onCloseModal,
	title,
	description
}: Props) => (
	<Modal
		className='flex flex-col px-10 py-10'
		isOpen={isModalOpen}
		onCloseModal={onCloseModal}
	>
		<Typography color='text-product' text={title} variant='h2' />
		<Typography
			class='mt-4'
			color='text-black-200'
			text='Coming Soon...'
			variant='text2'
		/>

		<HorizontalDivider className='my-6' />

		<Typography color='text-black-200' text={description} variant='text1' />

		<Button className='mt-8' onClick={onCloseModal} text='Close' />
	</Modal>
)

export { ComingSoonModal }
